// Shared formatters. `formatDate` was previously duplicated verbatim across
// Servers/Apps/ServerDetail/AppDetail.

// `DD.MM.YYYY HH:mm:ss UTC` — all timestamps in the app are shown in UTC so
// that they line up with the server-side check schedule.
export const formatDate = (date) => {
  if (!date) return 'Never';
  return new Date(date).toLocaleString('en-GB', {
    timeZone: 'UTC',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).replace(',', '').replace(/\//g, '.') + ' UTC';
};
